import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
    page: number;          // zero-indexed
    totalPages: number;
    total: number;
    offset: number;
    shown: number;
    onChange: (next: number) => void;
}

/**
 * Shared pagination footer for data tables. Sits at the bottom of a
 * .section-card with --flush body. Range labels are tabular-nums so the
 * digits don't jitter as the user pages.
 */
export function Pagination({
    page,
    totalPages,
    total,
    offset,
    shown,
    onChange,
}: PaginationProps): React.ReactElement {
    return (
        <div className="section-card__footer">
            <span className="tabular-nums">
                {total === 0 ? "0" : `${(offset + 1).toLocaleString()}–${(offset + shown).toLocaleString()}`}
                {" "}of {total.toLocaleString()}
            </span>
            <div className="cluster-xs">
                <button
                    type="button"
                    className="btn btn--ghost btn--sm press-crush"
                    disabled={page === 0}
                    onClick={() => onChange(page - 1)}
                    aria-label="Previous page"
                >
                    <ChevronLeft size={14} aria-hidden />
                </button>
                <span className="tabular-nums" style={{ minWidth: 56, textAlign: "center" }}>
                    {(page + 1).toLocaleString()} / {totalPages.toLocaleString()}
                </span>
                <button
                    type="button"
                    className="btn btn--ghost btn--sm press-crush"
                    disabled={page >= totalPages - 1}
                    onClick={() => onChange(page + 1)}
                    aria-label="Next page"
                >
                    <ChevronRight size={14} aria-hidden />
                </button>
            </div>
        </div>
    );
}
